// extracted by mini-css-extract-plugin
export var container = "_c6-0";